import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navigation />
      <main className="flex-1 flex items-center justify-center paper-texture px-4">
        <div className="max-w-md text-center py-20">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-accent/10 mb-6">
            <CheckCircle className="w-8 h-8 text-accent" />
          </div>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4">
            You're in.
          </h1>
          <p className="text-foreground/80 text-lg leading-relaxed mb-8">
            Check your inbox for a welcome note from Rebecca.
          </p>
          <Button asChild className="bg-primary hover:bg-accent text-primary-foreground font-mono uppercase tracking-wider">
            <Link to="/">Back to Home</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
